module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Subscript-5fee7963e960bab898519101e8c72dc4.svg";